import React from 'react'
import Skeleton from 'react-loading-skeleton'

export const OrderConfirmationLoading = () => {
  return (
    <div className='orderConfirmation' data-testid='order-confirmation-loading'>
      <div className='leftColumnWrapper'>
        {/* OrderStatusSection skeleton */}
        <div className='contentWrapper'>
          <div
            className='orderConfirmationSection'
            data-testid='order-status-section'
          >
            <Skeleton
              circle
              width={80}
              height={80}
              className='orderStatusIcon'
            />
            <div className='orderStatusText skeletonContainer'>
              <Skeleton
                width='60%'
                height={32}
                style={{ marginBottom: '8px' }}
              />
              <Skeleton width='80%' height={20} />
            </div>
            <div className='orderStatusStepper skeletonContainer'>
              <Skeleton width='100%' height={8} style={{ marginTop: '16px' }} />
            </div>
          </div>
          {/* FulfillmentSection skeleton */}
          <div
            className='orderConfirmationSection smallPadding'
            data-testid='fulfillment-section'
          >
            <div className='skeletonContainer'>
              <Skeleton
                width='50%'
                height={28}
                style={{ marginBottom: '8px' }}
              />
              <Skeleton width='70%' height={18} />
            </div>
          </div>

          {/* BehaviorSection skeleton */}
          <div
            className='orderConfirmationSection mediumPadding leftAlign'
            data-testid='behavior-section'
          >
            <div className='behaviorSectionContent'>
              <Skeleton
                width='40%'
                height={24}
                style={{ marginBottom: '16px' }}
              />
              <div className='behaviorSectionItem'>
                <Skeleton circle width={24} height={24} />
                <div
                  className='textContainer'
                  style={{ flex: 1, marginLeft: '12px' }}
                >
                  <Skeleton
                    width='60%'
                    height={20}
                    style={{ marginBottom: '4px' }}
                  />
                  <Skeleton width='80%' height={16} />
                </div>
              </div>
              <div className='getInTouch' style={{ marginTop: '16px' }}>
                <div className='textContent'>
                  <Skeleton
                    width='50%'
                    height={20}
                    style={{ marginBottom: '4px' }}
                  />
                  <Skeleton width='70%' height={16} />
                </div>
                <Skeleton
                  width='50%'
                  height={20}
                  style={{ marginBottom: '4px' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='rightColumnWrapper'>
        <div className='contentWrapper'>
          {/* OrderSummarySection skeleton */}
          <div
            className='orderConfirmationSection mediumPadding leftAlign summarySection'
            data-testid='order-summary-section'
          >
            <Skeleton
              width='40%'
              height={24}
              style={{ marginBottom: '16px' }}
            />
            <div className='cartOrder'>
              <div className='cartData'>
                {/* Order items skeleton */}
                {[1, 2, 3].map((item) => (
                  <div key={item} style={{ marginBottom: '16px' }}>
                    <Skeleton
                      width='70%'
                      height={18}
                      style={{ marginBottom: '4px' }}
                    />
                    <Skeleton width='40%' height={16} />
                  </div>
                ))}
                {/* Order prices skeleton */}
                <div style={{ marginTop: '24px' }}>
                  {[1, 2, 3, 4, 5].map((line) => (
                    <div
                      key={line}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '8px'
                      }}
                    >
                      <Skeleton width='40%' height={16} />
                      <Skeleton width='20%' height={16} />
                    </div>
                  ))}
                </div>
                {/* Total price skeleton */}
                <div
                  className='prices totalPriceContainer'
                  style={{ marginTop: '16px' }}
                >
                  <div className='cart-flex-row'>
                    <Skeleton width='30%' height={20} />
                    <Skeleton width='25%' height={20} />
                  </div>
                </div>
                {/* Order placed skeleton */}
                <div
                  className='prices totalPriceContainer'
                  style={{ marginTop: '16px' }}
                >
                  <div className='cart-flex-row'>
                    <Skeleton width='30%' height={20} />
                    <Skeleton width='25%' height={20} />
                  </div>
                  <div className='cart-flex-row'>
                    <Skeleton width='30%' height={20} />
                    <Skeleton width='25%' height={20} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
